import React, { useContext, useEffect } from 'react'

import AgencyConfirmation from '../AgencyConfirmation'
import EDDDialogue from './EDDDialogue'
import { DataContext } from '../DataContext'

const EDD = () => {
    const { activeAgency, setActiveAgency, formType } = useContext(DataContext)

    useEffect(() => {
        if (formType.FormType === `DepthProfile`) {
            setActiveAgency('WYDEQ')
        }
    }, [formType])

    return activeAgency ? (
        <EDDDialogue />
    ) : (
        <AgencyConfirmation onSubmit={setActiveAgency} />
    )
}

export default EDD